import React, { useState, useEffect } from "react";
import Button from "sushiweb/Button";
import {
  BottomSectionModal,
  FlexContainer,
} from "../../../constants/assets/containers";
import { connect } from "react-redux";
import NoFooterModal from "../../Common/NoFooterModal";
import InfiniteScrollDropdown from "../../Common/InfiniteScrollDropdown";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import Input from "sushiweb/InputTypes/Input";
import { bindActionCreators } from "redux";
import * as CountryActions from "../../../store/actions/Country";
import * as StateActions from "../../../store/actions/State";
import * as CityActions from "../../../store/actions/City";
import * as LocalityActions from "../../../store/actions/Locality";
import * as DriverActions from "../../../store/actions/DriverServices";

import styled from "styled-components";
import { isValNull } from "../../../utils";

export const geographyLevelType = [
  { label: "Country", value: "country" },
  { label: "City", value: "city" },
  { label: "Locality", value: "locality" },
];

// To Do: If we select city after country UI breaks
const findCountryIdByIsoCode = (countryList, isoCode) => {
  let countryId = "";
  if (countryList.length) {
    for (let { id, iso_code } of countryList) {
      if (iso_code === isoCode) {
        countryId = id;
        break;
      }
    }
  }
  return countryId;
};

const GeographySelectionModal = (props) => {
  const {
    setModalState,
    inputFieldState,
    setInputFieldState,
    getInputLabel,
    newCampaignOptions,
    nextPageCountry,
    Country,
    getCountryList,
  } = props;

  const [formError, setFormError] = useState("");
  const indiaCode = findCountryIdByIsoCode(Country?.countryList || [], "IND");

  const [driverServicesPriorityFlag, setDriverServicesPriorityFlag] =
    useState(true);
  const [cityPriorityFlag, setCityPriorityFlag] = useState(true);
  const [statePriorityFlag, setStatePriorityFlag] = useState(false);
  const [countryPriorityFlag, setCountryPriorityFlag] = useState(false);
  const [cityLocalityPriorityFlag, setCityLocalityPriorityFlag] =
    useState(false);
  const [localityPriorityFlag, setLocalityPriorityFlag] = useState(false);
  const [stateCityPriorityFlag, setStateCityPriorityFlag] = useState(false);

  const handleClose = () => {
    setInputFieldState((prevState) => {
      return {
        ...prevState,
        geography_details: {
          geography_level: "",
          country_id: `${indiaCode}`,
          state_ids: [],
          city_ids: [],
          loality_city_ids: [],
          locality_ids: [],
          driver_service_ids: [],
          active_driver_option: "",
        },
        driver_selection_type: "",
      };
    });
    setModalState(false);
  };

  const validateGeographyDetails = () => {
    if (isValNull(inputFieldState.geography_details.geography_level)) {
      return "Geography level field is mandatory";
    }

    let err = "";
    Object.keys(inputFieldState.geography_details).map((key) => {
      if (isValNull(inputFieldState.geography_details[key])) {
        switch (inputFieldState.geography_details.geography_level) {
          case "state":
            if (key == "state_ids") {
              err = "State field is mandatory";
            }
            break;
          case "city":
            if (key == "city_ids") {
              err = "City field is mandatory";
            }
            break;
          case "locality":
            if (key == "locality_ids") {
              err = "Locality field is mandatory";
            }
            break;
        }
      }
    });

    return err ? err : "validated";
  };

  const handleSubmit = () => {
    let validatedState = validateGeographyDetails();
    if (validatedState === "validated") {
      setModalState(false);
    } else {
      setFormError(validatedState);
    }
  };

  const handleChange = (key, val) => {
    var geographyDetails = inputFieldState.geography_details;
    geographyDetails[key] = val;
    if (key == "geography_level") {
      setTimeout(() => {
        switch (val) {
          case "city":
            setCityPriorityFlag(true);
            break;
          case "state":
            setStatePriorityFlag(true);
            break;
          case "country":
            setCountryPriorityFlag(true);
            break;
          case "locality":
            setCityLocalityPriorityFlag(true);
            setLocalityPriorityFlag(true);
            break;
        }
      }, 100);
    }
    if (key == "locality_city_ids") {
      if (geographyDetails[key].length == 0) {
        geographyDetails["locality_ids"] = [];
      } else {
        setLocalityPriorityFlag(true);
      }
    }
    if (key == "state_city_ids") {
      if (geographyDetails[key].length == 0) {
        geographyDetails["city_ids"] = [];
      } else {
        setCityPriorityFlag(true);
      }
    }
    setInputFieldState((prevState) => {
      return { ...prevState, geography_details: geographyDetails };
    });
  };

  const getConfirmButton = () => {
    return (
      <BottomSectionModal className="flex justify-center ">
        <Button
          data-testid="submitGeographyDetailsModal"
          className="sushi-btn"
          onClick={handleSubmit}
        >
          Confirm
        </Button>
      </BottomSectionModal>
    );
  };

  const getGeographySelectedDropdown = () => {
    switch (inputFieldState.geography_details.geography_level) {
      case "country":
        return <Input value="India" id="sushi-input" disabled={true} />;
      case "state":
        return (
          <InfiniteScrollDropdown
            priorityFlag={statePriorityFlag}
            setPriorityFlag={setStatePriorityFlag}
            id="driverCommStateDropdown"
            getActiveList={props.getStateList}
            nextPage={props.nextPageState}
            resKey="states"
            modalState="Edit"
            keyName="state_ids"
            labelKey="name"
            getDataLabelKey="state.name"
            keyTypeToSet="id"
            label="State"
            handleChange={handleChange}
            remoteSearchApplicable
            activeElement={inputFieldState.geography_details}
            appliedFilters={{}}
            getActiveItemById={props.getBulkStates}
            remoteSearchKey="startswith"
            multiple
          />
        );

      case "city":
        return (
          <InfiniteScrollDropdown
            priorityFlag={cityPriorityFlag}
            setPriorityFlag={setCityPriorityFlag}
            id="driverCommCityDropdown"
            getActiveList={props.getCityList}
            nextPage={props.nextPageCity}
            resKey="cities"
            modalState="Edit"
            keyName="city_ids"
            labelKey="city_name"
            getDataLabelKey="city.city_name"
            keyTypeToSet="id"
            label="City"
            handleChange={handleChange}
            remoteSearchApplicable
            remoteSearchKey="startswith"
            activeElement={inputFieldState.geography_details}
            appliedFilters={{}}
            getActiveItemById={props.getBulkCities}
            multiple
          />
        );
      case "locality":
        return (
          <InfiniteScrollDropdown
            priorityFlag={localityPriorityFlag}
            setPriorityFlag={setLocalityPriorityFlag}
            id="driverCommLocalityDropdown"
            getActiveList={props.getLocalityList}
            nextPage={props.nextPageLocality}
            resKey="localities"
            modalState="Edit"
            keyName="locality_ids"
            labelKey="locality_name"
            getDataLabelKey="locality.locality_name"
            keyTypeToSet="id"
            label="Locality"
            handleChange={handleChange}
            remoteSearchApplicable
            activeElement={inputFieldState.geography_details}
            getActiveItemById={props.getBulkLocalities}
            appliedFilters={
              inputFieldState.geography_details.locality_city_ids
                ? {
                    city_id:
                      inputFieldState.geography_details.locality_city_ids,
                  }
                : {}
            }
            remoteSearchKey="startswith"
            disabled={isValNull(
              inputFieldState.geography_details.locality_city_ids
            )}
            multiple
          />
        );
    }
  };

  useEffect(() => {
    const geoDets = inputFieldState.geography_details.geography_level;
    getCountryList();
    switch (geoDets) {
      case "city":
        setCityPriorityFlag(true);
        setStateCityPriorityFlag(true);
        break;
      case "state":
        setStatePriorityFlag(true);
        break;
      case "country":
        setCountryPriorityFlag(true);
        break;
      case "locality":
        // setCityPriorityFlag(true);
        setCityLocalityPriorityFlag(true);
        setLocalityPriorityFlag(true);
        break;
    }
  }, []);

  useEffect(() => {
    setInputFieldState((prevState) => {
      const { geography_details } = { ...prevState };
      geography_details.country_id = indiaCode;
      return { ...prevState, geography_details };
    });
  }, [Country]);

  return (
    <NoFooterModal
      header={true}
      heading="Select Geography and Driver Details"
      handleClose={handleClose}
      id="GeographyDetailsModal"
      modalButtons={getConfirmButton()}
    >
      <div>
        <FlexContainer className="justify-start">
          <NamesDiv>
            <p className="regular ml-10 mb-30">Select Geography Level</p>
          </NamesDiv>
          <InputElements>
            <PaginatedReactDropdown
              placeholder=""
              options={geographyLevelType}
              labelKey="label"
              valueKey="value"
              data-testid="geographyLevelType"
              value={getInputLabel(
                inputFieldState.geography_details.geography_level,
                geographyLevelType,
                "value",
                "label"
              )}
              handleChange={handleChange}
              keyToChange="geography_level"
              id="geographyLevelType"
            />
          </InputElements>
        </FlexContainer>
        {inputFieldState.geography_details.geography_level == "locality" && (
          <FlexContainer className="justify-start">
            <NamesDiv>
              <p className="regular ml-10 mb-30">Select city for localities</p>
            </NamesDiv>
            <InputElements>
              <InfiniteScrollDropdown
                priorityFlag={cityLocalityPriorityFlag}
                setPriorityFlag={setCityLocalityPriorityFlag}
                id="driverCommCity2Dropdown"
                getActiveList={props.getCityList}
                nextPage={props.nextPageCity}
                resKey="cities"
                modalState="Edit"
                keyName="locality_city_ids"
                labelKey="city_name"
                getDataLabelKey="city.city_name"
                keyTypeToSet="id"
                label="Locality Cities"
                handleChange={handleChange}
                remoteSearchApplicable
                remoteSearchKey="startswith"
                activeElement={inputFieldState.geography_details}
                appliedFilters={{}}
                getActiveItemById={props.getBulkCities}
                multiple
              />
            </InputElements>
          </FlexContainer>
        )}
        <FlexContainer className="justify-start">
          <NamesDiv>
            <p className="regular ml-10 mb-30">
              {getInputLabel(
                inputFieldState.geography_details.geography_level,
                geographyLevelType,
                "value",
                "label"
              )}
            </p>
          </NamesDiv>
          <InputElements>{getGeographySelectedDropdown()}</InputElements>
        </FlexContainer>
      </div>
      {formError.length > 0 ? (
        <div className={"error-state"}>{"*" + formError}</div>
      ) : (
        ""
      )}
    </NoFooterModal>
  );
};

const NamesDiv = styled.div`
  justify-content: flex-start;
  flex: 0 1 38%;
  p {
    font-family: "OkraRegular", -apple-system, BlinkMacSystemFont, "Segoe UI",
      Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue",
      sans-serif !important;
  }
`;

const InputElements = styled.div`
  flex: 0 1 62%;
`;

function mapStateToProps(state) {
  const { Country, State, City, Locality } = state;
  return {
    nextPageCountry: Country.nextPage,
    nextPageState: State.nextPage,
    nextPageCity: City.nextPage,
    nextPageLocality: Locality.nextPage,
    Country,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    getCountryList: bindActionCreators(CountryActions.getCountryList, dispatch),
    getCountry: bindActionCreators(CountryActions.getCountry, dispatch),
    getStateList: bindActionCreators(StateActions.getStateList, dispatch),
    getBulkStates: bindActionCreators(StateActions.getBulkStates, dispatch),
    getCityList: bindActionCreators(CityActions.getCityList, dispatch),
    getBulkCities: bindActionCreators(CityActions.getBulkCities, dispatch),
    getLocalityList: bindActionCreators(
      LocalityActions.getLocalityList,
      dispatch
    ),
    getBulkLocalities: bindActionCreators(
      LocalityActions.getBulkLocalities,
      dispatch
    ),
    getDriverServices: bindActionCreators(
      DriverActions.getDriverServices,
      dispatch
    ),
    getDriverServiceByIds: bindActionCreators(
      DriverActions.getDriverServiceByIds,
      dispatch
    ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GeographySelectionModal);
